import "../../App.css";
import splash from "../../img/splash.jpg";

function Home({ handleClick, opening, msg }) {
  return (
    <div>
      <section class="color--color1">
        <div class="section--bg img--bg">
          <img class="first" src={splash} alt="" />
        </div>
        <div className="in display_flex">
          <main>
            {!opening ? (
              <>
                <div className="ttl text--center home_title opening_box">
                  <p
                    className={
                      msg.length > 300
                        ? "titular medium home_subtitle msg size2"
                        : "titular medium home_subtitle msg"
                    }
                  >
                    {" "}
                    {msg
                      ? msg
                      : "¡Gracias por preferirnos! Nuestro simulador ya ha finalizado su proceso, te esperamos para la Admisión 2027, ¡nos vemos! TKM :D"}
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className="ttl text--center home_title">
                  <h2 class="huge titular">Carreras Vespertinas 2027</h2>
                  <div class="titular medium home_subtitle">
                    Descuentos desde el 25% en arancel.
                  </div>
                  <div class="titular medium home_subtitle">
                    Matrícula gratis.
                  </div>
                </div>

                <div class="button submit style--2">
                  <button onClick={handleClick}>
                    <strong>Comienza tu simulación &darr;</strong>
                  </button>
                </div>
              </>
            )}
          </main>
        </div>
      </section>
    </div>
  );
}

export default Home;
